import { useParams } from 'react-router'
import { ApplicationInformation } from 'src/screens/shared/application/details/application-information/ApplicationInformation'

export const PfKapApplicationInformationPage = () => {
  const { projectId } = useParams()
  const pf_kap_id = parseInt(projectId as string)

  return <ApplicationInformation baseUrl="/pf-kap" projectId={pf_kap_id} />
}
